import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'

const InfoIcon = ({circleColor = 'currentColor', ...props}) => {
    return (
        <Icon viewBox="0 0 24 24" data-testid="info-icon" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                fill={circleColor}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13 10V18H11V10H13ZM13 8V6H11V8H13Z"
                fill="currentColor"
            />
        </Icon>
    )
}

InfoIcon.propTypes = {circleColor: PropTypes.string}
export default InfoIcon
